// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"694293e9","115":"9a6813a7","350":"ae8574b1","521":"fc823545","575":"650bae5b","604":"b3001256","638":"89a7a2db","686":"3ab4121a","730":"816dc028","818":"9bec9b79","819":"30c98a25"}[chunkId] + ".chunk.js";
};